<section class="home-free-consultation-wrapper">
  <div class="home-free-consultation-wrapper_headline-w">
    <h2>{{'home-page.free-consultation-headline' | translate}}</h2>
    <p>{{'home-page.free-consultation-text' | translate}}</p>
  </div>

  <div class="home-free-consultation-wrapper_heading-texts-w">
    <app-heading-text-wrapper
      [textIcon] ="'assets/svgs/text-heading-icon.svg'"
      [headingText]="'home-page.free-consultation-when-headline' | translate"
      [bodyText]="'home-page.free-consultation-when-text' | translate"
    />

    <app-heading-text-wrapper
      [textIcon] ="'assets/svgs/text-heading-icon.svg'"
      [headingText]="'home-page.free-consultation-what-headline' | translate"
      [bodyText]="'home-page.free-consultation-what-text' | translate"
    />

    <app-heading-text-wrapper
      [textIcon] ="'assets/svgs/text-heading-icon.svg'"
      [headingText]="'home-page.free-consultation-how-headline' | translate"
      [bodyText]="'home-page.free-consultation-how-text' | translate"
    />
  </div>

  <div class="home-free-consultation-wrapper_lets-talk-img-text-w">
    <div class="home-free-consultation-wrapper_lets-talk-img-text-w_image">
      <img src="../../../../assets/images/home-page/free-consultation.png" alt="consultation"/>
    </div>

    <div class="home-free-consultation-wrapper_lets-talk-img-text-w_text">
      <app-heading-text-wrapper
        [headingText]="'home-page.free-consultation-lets-talk-headline' | translate"
        [bodyText]="'home-page.free-consultation-lets-talk-text' | translate"
      />

      <div class="home-free-consultation-wrapper_lets-talk-img-text-w_text-btn-w">
        <app-button
          [label]="'home-page.free-consultation-btn' | translate"
          [href]="'/consultation'"
        />
      </div>
    </div>
  </div>

</section>
